<template>
  <div>
    <div class="w-full px-6 h-20 flex justify-center items-center border-b relative">
      <h4 class="text-yank">Media Collections</h4>
      <div v-if="! $page.props.user" class="absolute right-0 inset-y-0 hidden lg:flex items-center mr-10">
        <AuthButtons />
      </div>
    </div>

    <!--All collections-->
    <section class="px-10 py-12">
      <h4 class="font-bold text-2xl mb-4">All collections</h4>
      <div class="items-grid">
        <CollectionComponent :collection="collection" v-for="collection in collections.data" :key="collection.uuid"/>
      </div>

      <infinite-loading v-if="collections.meta.last_page > 1" ref="infiniteLoader" @infinite="loadMore">
        <div slot="spinner" class="items-grid mt-8">
          <item-skeleton v-for="item in 10" :key="`skeleton-item-${item}`" />
        </div>
        <div slot="no-more" class="mt-8 text-sm font-medium text-payneFire">No more collections to display</div>
        <div slot="no-results" class="mt-8 text-sm font-medium text-payneFire">No more collections to display</div>
      </infinite-loading>
    </section>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import AuthButtons from "@/components/shared/AuthButtons"
  import AppLayout from '@/layout/app-layout'
  import CollectionComponent from '@/components/shared/CollectionComponent'
  import ItemSkeleton from "@/components/shared/ItemSkeleton"
  export default {
    name: 'CollectionsIndex',

    metaInfo() {
      return {
        title: 'Collections',
      }
    },

    layout: AppLayout,

    props: {
      collections: Object,
    },

    components: {
      CollectionComponent,
      ItemSkeleton,
      InfiniteLoading,
      AuthButtons,
    },

    remember: ['allCollections'],

    data() {
      return {
        allCollections: this.collections.data,
      }
    },

    watch: {
      collections(collections) {
        this.allCollections.push(...collections.data)
      }
    },

    methods: {
      loadMore($state) {
        if (! this.collections.links.next) {
          return
        }

        this.$inertia.visit(this.collections.links.next, {
          preserveState: true,
          preserveScroll: true,
          only: ['collections'],
          onFinish: () => {
            $state.loaded()
            if (! this.collections.links.next) {
              $state.complete()
            }
          }
        })
      }
    },

    mounted() {
      if (this.collections.meta.last_page > 1 && ! this.collections.links.next) {
        this.$refs.infiniteLoader.stateChanger.loaded()
        this.$refs.infiniteLoader.stateChanger.complete()
      }
    }
  }
</script>
